
/**
 * @export
 * @enum {string}
 */
export enum ProductSubscriptionLifecycleStatus {
    PENDING = 'PENDING',
    ACTIVE = 'ACTIVE',
    EXPIRED = 'EXPIRED',
    CANCELLED = 'CANCELLED'
}